//messages.js
export default {
    category_id: "Category #",
    category_name: "Category Name",
    category_description: "Category Description",
    edit_fe_part_category: "Edit Fe Part Category",
    add_fe_part_category: "Add Fe Part Category",
    delete_fe_part_category: "Delete Fe Part Category",
    fe_part_categories: "Part Categories",
    delete_fe_part_category_confirm: "This action is not reversible!",
};
